const rules = {
  USA: {
    AL: /^([0-9]{7,8})$/,
    AK: /^\d{1,7}$/,
    AZ: /^[A-Z]\d{8,9}$/,
    AR: /^\d{4,9}$/,
    CA: /^[A-Z]\d{7}$/,
    CO: /^(\d{9})\b|\b([A-Z]\d{3,6})\b|\b([A-Z]{2}\d{2,5})$/,
    CT: /^(\d{9})$/,
    DE: /^(\d{1,7})$/,
    DL: /^([A-Z]\d{6})\b|\b(\d{7,8})$/,
    DC: /^(\d{9})\b|\b(\d{7})$/,
    FL: /^([A-Z]\d{12})$/,
    GA: /^(\d{7,9})$/,
    HI: /^([A-Z]\d{8})\b|\b(\d{9})$/,
    ID: /^([A-Z]{2}\d{6}[A-Z])\b|\b(\d{9})$/,
    IL: /^([A-Z]\d{11})|([A-Z]\d{12})$/,
    IN: /^([A-Z]\d{9})\b|\b(\d{9,10})$/,
    IA: /^(\d{9})\b|\b(\d{3}[A-Z]{2}\d{4})$/,
    KS: /^([A-Z]\d[A-Z]\d[A-Z])\b|\b(([A-Z]|\d)\d{8})$/,
    KY: /^([A-Z]\d{8,9})\b|\b(\d{9})$/,
    LA: /^(\d{1,9})$/,
    ME: /^(\d{7}([A-Z]|\d))\b|\b(\d{7})$/,
    MD: /^([A-Z]\d{12})$/,
    MA: /^([A-Z]\d{8})\b|\b([A-Z]{2}\d{7})\b|\b(\d{9})$/,
    MI: /^([A-Z]\d{12})\b|\b([A-Z]\d{10})$/,
    MN: /^([A-Z]\d{12})\b|\b([A-Z]\d{3}-\d{3}-\d{3}-\d{3})$/,
    MS: /^(\d{9})$/,
    MO: /^([A-Z]\d{6}R)\b|\b([A-Z]\d{5,9})\b|\b(\d{8}[A-Z]{2})\b|\b(\d{9}[A-Z])\b|\b(\d{9})\b|\b(\d{3}[A-Z]\d{6})$/,
    MT: /^([A-Z]\d{8})\b|\b(\d{13,14})\b|\b(\d{9})|\b([A-Z]{3}\d{10})$/,
    NE: /^([A-Z]\d{6,8})$/,
    NV: /^(\d{12})\b|\b(\d{9,10})\b|\b(X\d{8})$/,
    NH: /^(\d{2}[A-Z]{3}\d{5})\b|\b([A-Z]{3}\d{8})$/,
    NJ: /^([A-Z]\d{14})$/,
    NM: /^(\d{8,9})$/,
    NY: /^(\d{16})\b|\b(\d{8,9})\b|\b([A-Z]\d{18})\b|\b([A-Z]\d{7,8})\b|\b([A-Z]{8})$/,
    NC: /^(\d{1,12})$/,
    ND: /^([A-Z]{3}\d{6})\b|\b(\d{9})$/,
    OH: /^([A-Z]\d{4,8})\b|\b([A-Z]{2}\d{3,7})\b|\b(\d{8})$/,
    OK: /^([A-Z]\d{9})\b|\b(\d{9})$/,
    OR: /^([A-Z]\d{6})\b|\b(\d{5,7})$/,
    PA: /^(\d{8})$/,
    RI: /^([A-Z]\d{6})\b|\b(\d{7,8})$/,
    SC: /^(\d{5,11})$/,
    SD: /^(\d{12})\b|\b(\d{6,10})$/,
    TN: /^(\d{7,9})$/,
    TX: /^(\d{7,8})$/,
    UT: /^(\d{4,10})$/,
    VT: /^(\d{7}(A|\d))$/,
    VA: /^([A-Z]\d{8,11})\b|\b(\d{9})$/,
    WA: /^(([A-Z]|\*|\d){12})$/,
    WV: /^(\d{7})\b|\b([A-Z]{1,2}\d{5,6})$/,
    WI: /^([A-Z]\d{13})$/,
    WY: /^(\d{9,10})$/,
    Default: /^.*$/
  },
  Default: {
    Default: /^.*$/
  }
}

export const USCountryVariations = {
  USA: ['United States', 'United States of America', 'US', 'USA', 'us', 'usa', 'America', 'U.S.', 'U.S.A.']
}

export function ValidateLicense(country, state, dl) {
  let countryKey = 'Default'
  for (const key in USCountryVariations) {
    if (USCountryVariations[key].includes(country)) {
      countryKey = key
      break
    }
  }

  const rule = rules[countryKey][(state || '').toUpperCase()] || rules[countryKey]['Default']
  return rule.test(dl)
}

export function validateState(state) {
  const stateAbbreviations = Object.keys(rules.USA)
  return stateAbbreviations.indexOf(state) !== -1
}
